module.exports = __webpack_public_path__ + "static/media/buy_req_make_5.c69eb852.jpg";